import React from 'react';
import { motion } from 'framer-motion';
import TopBar from '../components/TopBar';
import SafeIcon from '../common/SafeIcon';
import { rooms } from '../data/mockData';

export default function Rooms() {
  return (
    <div className="flex-1 overflow-y-auto w-full h-full bg-mesh-pattern pb-32">
      <TopBar title="Live Frequencies" />
      
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
          <div>
            <h3 className="text-lg font-semibold text-white">Active Listening Rooms</h3>
            <p className="text-sm text-gray-400">Join a synchronized audio experience.</p>
          </div>
          <button className="px-4 py-2 bg-vinyl-800 border border-plasma/50 text-plasma rounded-lg hover:bg-plasma hover:text-white transition-all glow-plasma flex items-center gap-2">
            <SafeIcon icon="FiRadio" /> Broadcast Room
          </button>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rooms.map((room, idx) => (
            <motion.div
              key={room.id}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: idx * 0.1 }}
              className="glass-panel p-6 rounded-2xl relative overflow-hidden group hover:border-aqua/50 transition-colors cursor-pointer"
            >
              {/* Animated background pulse */}
              <div className="absolute -inset-4 bg-gradient-to-r from-plasma/5 to-aqua/5 opacity-0 group-hover:opacity-100 animate-pulse-fast transition-opacity" />
              
              <div className="flex justify-between items-start mb-4 relative z-10">
                <div>
                  <span className="text-[10px] uppercase font-bold tracking-wider text-aqua mb-1 block">
                    {room.genre}
                  </span>
                  <h4 className="text-xl font-display font-bold text-white mb-1 group-hover:text-glow-aqua transition-all">{room.name}</h4>
                  <p className="text-sm text-gray-400 flex items-center gap-1">
                    <SafeIcon icon="FiUser" className="text-xs" /> Host: {room.host}
                  </p>
                </div>
                <div className="flex items-center gap-1 bg-vinyl-900/80 px-2 py-1 rounded text-xs text-plasma font-medium border border-plasma/30">
                  <span className="w-2 h-2 rounded-full bg-plasma animate-pulse" />
                  {room.listeners}
                </div>
              </div>

              <div className="flex gap-2 mb-6 relative z-10">
                {room.tags.map(tag => (
                  <span key={tag} className="text-[10px] px-2 py-1 rounded-full bg-vinyl-700 text-gray-300">
                    #{tag}
                  </span>
                ))}
              </div>

              <div className="flex items-center justify-between relative z-10">
                <div className="flex -space-x-2">
                  {[1,2,3].map(i => (
                    <img key={i} src={`https://i.pravatar.cc/100?img=${i + idx * 3}`} alt="Listener" className="w-8 h-8 rounded-full border-2 border-vinyl-800" />
                  ))}
                  <div className="w-8 h-8 rounded-full border-2 border-vinyl-800 bg-vinyl-700 flex items-center justify-center text-[10px] text-gray-400">
                    +{room.listeners - 3}
                  </div>
                </div>
                <button className="w-10 h-10 rounded-full bg-white text-vinyl-900 flex items-center justify-center group-hover:scale-110 transition-transform shadow-[0_0_15px_rgba(255,255,255,0.2)]">
                  <SafeIcon icon="FiArrowRight" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}